/* eslint-disable no-confusing-arrow */
import styled from 'styled-components'

import { NavLink as NavLinkRaw } from 'react-router-dom'

export const MenuDetailedWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start; 
  height: 100%;
  padding: 20px 0; 
  width: 100%;
  min-width: 190px;

  & svg { 
    & path { stroke: ${({ theme }) => theme.colors.primary}}
    & line  {stroke: ${({ theme }) => theme.colors.primary}}
    & polyline  {stroke: ${({ theme }) => theme.colors.primary}}
    & g path{fill: ${({ theme }) => theme.colors.primary} !important}
  }
`
export const Divider = styled.div`
  width: 100%;
  padding: 0 20px;
  height: 1px;
  background-color: ${({ theme }) => theme.colors.borderColor};
`
export const Header = styled.div`
  line-height: 120%;
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.primary};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
export const Text = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.secondary};
`
export const XStack = styled.div`
  display: flex;
  width: 100%;
`
export const YStack = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const MenuNavLink = styled(NavLinkRaw)`
  width: 100%;
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.primary};
  transition: .3s;
  padding: 8px 16px;
  border-radius: 8px;

  &:hover{
    font-weight: 600; 
    color: ${({ theme }) => theme.colors.primary};
    background-color: ${({ theme }) => theme.colors.borderColor};
  }
`
export const Btn = styled.div`
  cursor: pointer;
  width: 100%;
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.primary};
  transition: .3s;
  padding: 8px 16px;
  border-radius: 8px;

  &:hover{
    font-weight: 600; 
    color: ${({ theme }) => theme.colors.primary};
    background-color: ${({ theme }) => theme.colors.borderColor};
  }
`
